// extracted by mini-css-extract-plugin
module.exports = {"Layout":"Layout_Layout__3OGK4","body":"Layout_body__ZSVvR","auth":"Layout_auth__WBElD","content":"Layout_content__3Usg-"};